"use client";
import React from "react";
class CellErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    console.log("Cell failure: ", {
      error,
      errorInfo
    });
  }
  render() {
    const { renderFallback } = this.props;
    if (this.state.hasError) {
      return renderFallback({
        error: this.state.error,
        resetErrorBoundary: () => {
          this.setState({ hasError: false, error: void 0 });
        }
      });
    }
    return this.props.children;
  }
}
export {
  CellErrorBoundary
};
